/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AnalysePageWrapper_analyse_Posts$ref: FragmentReference;
declare export opaque type AnalysePageWrapper_analyse_Posts$fragmentType: AnalysePageWrapper_analyse_Posts$ref;
export type AnalysePageWrapper_analyse_Posts = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +title: string,
      +created: string,
      +body: string,
    |}
  |}>,
  +$refType: AnalysePageWrapper_analyse_Posts$ref,
|};
export type AnalysePageWrapper_analyse_Posts$data = AnalysePageWrapper_analyse_Posts;
export type AnalysePageWrapper_analyse_Posts$key = {
  +$data?: AnalysePageWrapper_analyse_Posts$data,
  +$fragmentRefs: AnalysePageWrapper_analyse_Posts$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnalysePageWrapper_analyse_Posts",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PostNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PostNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "body",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PostNodeConnection",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '27bd3f40c98359667e177e515283aaf6';

module.exports = node;
